/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ComponentTypeStatus } from './ComponentTypeStatus';
import {
    ComponentTypeStatusFromJSON,
    ComponentTypeStatusFromJSONTyped,
    ComponentTypeStatusToJSON,
    ComponentTypeStatusToJSONTyped,
} from './ComponentTypeStatus';

/**
 * 
 * @export
 * @interface UpdateComponentTypeRequestDto
 */
export interface UpdateComponentTypeRequestDto {
    /**
     *  status for the ComponentType
     * @type {ComponentTypeStatus}
     * @memberof UpdateComponentTypeRequestDto
     */
    status?: ComponentTypeStatus;
    /**
     * Name of the ComponentType
     * @type {string}
     * @memberof UpdateComponentTypeRequestDto
     */
    name?: string;
    /**
     * List of synonyms for this ComponentType
     * @type {Array<string>}
     * @memberof UpdateComponentTypeRequestDto
     */
    synonyms?: Array<string>;
}



/**
 * Check if a given object implements the UpdateComponentTypeRequestDto interface.
 */
export function instanceOfUpdateComponentTypeRequestDto(value: object): value is UpdateComponentTypeRequestDto {
    return true;
}

export function UpdateComponentTypeRequestDtoFromJSON(json: any): UpdateComponentTypeRequestDto {
    return UpdateComponentTypeRequestDtoFromJSONTyped(json, false);
}

export function UpdateComponentTypeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateComponentTypeRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : ComponentTypeStatusFromJSON(json['status']),
        'name': json['name'] == null ? undefined : json['name'],
        'synonyms': json['synonyms'] == null ? undefined : json['synonyms'],
    };
}

export function UpdateComponentTypeRequestDtoToJSON(json: any): UpdateComponentTypeRequestDto {
    return UpdateComponentTypeRequestDtoToJSONTyped(json, false);
}

export function UpdateComponentTypeRequestDtoToJSONTyped(value?: UpdateComponentTypeRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': ComponentTypeStatusToJSON(value['status']),
        'name': value['name'],
        'synonyms': value['synonyms'],
    };
}

